// Amounts are in cents. Group thousands with a thin space, e.g. 1234567 -> "12 345.67".
export const formatMoney = (amount: number, hideCents: boolean): string => {
    const str = hideCents ? Math.floor(amount / 100).toString() : (amount / 100).toFixed(2)

    return str.replace(/\d{1,3}(?=(\d{3})+(?!\d))/g, '$& ')
}

export const getAmountAfterHideCents = (amountBeforeHideCents: number, hideCents: boolean): number => {
    if (hideCents) return Math.floor(amountBeforeHideCents / 100)

    return amountBeforeHideCents
}
